import ContributorProfileBadge from './ContributorProfileBadge';

export default ContributorProfileBadge;
